import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Button,
  Autocomplete,
  FormControl,
  FormLabel,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from '@mui/material'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { toast } from 'react-toastify'
import { toastConfig } from '../../helpers/toastConfig'
import RootStore from '../../store/RootStore'
import { Unit } from '../../types/models/Unit'
import { CreateOrderDTO } from '../../types/models/Order'
import ProductCard from '../ProductCard/ProductCard'
import './styles/CreateOrder.scss'
import UserSelect from '../AppHeader/UserSelect'
import { grey, red } from '@mui/material/colors'

import TextFieldNumpad from '../forms/TextFieldNumpad'
import { UnitsStore } from '../../store/AdminPanel/Units.Store'

type Props = {}

const margin = 'dense'
const variant = 'standard'

const CreateOrder = observer((props: Props) => {
  const open = RootStore.modalsUi.createOrder
  const material = RootStore.modalsUi.material
  const locationPath = RootStore.modalsUi.locationPath

  const [quantity, setQuantity] = React.useState(0)
  const [assigned, setAssigned] = React.useState<number | undefined>(0)
  const [source, setSourse] = React.useState('Заказ')
  const [error, setError] = React.useState<any>()
  const [unitId, setUnit] = React.useState(0)

  const hundleClose = () => {
    setQuantity(0)
    setAssigned(0)
    RootStore.modalsUi.hundleCreateOrder(false)
  }

  const hundleChangeQuantity = (q: number) => {
    console.log(q)
    setQuantity(q)
    console.log(quantity)
  }

  const hundleChangeUnit = (unit: Unit) => {
    setUnit(unit.id)
  }

  if (!material) return <></>

  const hundleChange = async () => {
    const defunitId =  material?.units ? material?.units[0].id: 1  // кг
    const form: CreateOrderDTO = {
      materialId: material.id,
      locationPath: locationPath ? locationPath : undefined,
      quantity: quantity,
      unitId: unitId == 0 ? defunitId : 1,
      urgent: false,
      source: 'Заказ',
    }
  
    const toastId = toast.loading('Обработка...', toastConfig)

    try {
      await RootStore.userAction.createOrder(form)
      toast.update(toastId, {
        render: 'Успешно',
        type: 'success',
        isLoading: false,
        ...toastConfig,
      })
      setError(null)
      hundleClose()
    } catch (error: any) {
      const data = error.response?.data
      toast.update(toastId, {
        render: data?.message ?? 'Произошла ошибка',
        type: 'error',
        isLoading: false,
        ...toastConfig,
      })
      if (data.property) {
        setError(data.property)
      }
    }
  }

  const hundleChangeUrgent = async () => {
    const defunitId =  material?.units ? material?.units[0].id: 1  // кг
    const form: CreateOrderDTO = {
      materialId: material.id,
      locationPath: locationPath ? locationPath : undefined,
      quantity: quantity,
      unitId: unitId == 0 ? defunitId : 1,
      urgent: true,
      source: 'Заказ',
    }
  
    const toastId = toast.loading('Обработка...', toastConfig)

    try {
      await RootStore.userAction.createOrder(form)
      toast.update(toastId, {
        render: 'Успешно',
        type: 'success',
        isLoading: false,
        ...toastConfig,
      })
      setError(null)
      hundleClose()
    } catch (error: any) {
      const data = error.response?.data
      toast.update(toastId, {
        render: data?.message ?? 'Произошла ошибка',
        type: 'error',
        isLoading: false,
        ...toastConfig,
      })
      if (data.property) {
        setError(data.property)
      }
    }
  }

  return (
    <Dialog open={open} onClose={hundleClose}>
      <div className="CreateOrder">
        <div className="CreateOrder-content">
          <DialogTitle>Создать Заказ</DialogTitle>
          <div className="CreateOrder-inputs"> </div>
          <DialogContent>
            <TextFieldNumpad
              name={material.name}
              label="Количество"
              value={String(quantity)} // Convert quantity to stringquantity
              onChange={(event) => setQuantity(Number(event.target.value))}
              error={error?.quantity ?? null}
              helperText={ quantity > 0 ? 'Обязательное поле' : undefined }
            />

            <UserSelect />
            {material.units ? (
              <Autocomplete
                options={material.units}
                defaultValue={material.units[0]}
                onChange={(event: any, newValue) => {
                  if (!newValue) return
                  hundleChangeUnit(newValue)
                }}
                getOptionLabel={(option) => option.name}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="ЕИ"
                    placeholder="Выберите ЕИ"
                    variant={variant}
                    margin={margin}
                    error={error?.units ?? null}
                    helperText={error?.units ?? null}
                  />
                )}
              />
            ) : null}

          </DialogContent>
        </div>
      </div>

      <DialogActions
        style={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <Button color="error" onClick={hundleChangeUrgent}>Срочно!</Button>
        <div>
          <Button onClick={hundleChange}>Создать</Button>
          <Button onClick={hundleClose}>Отмена</Button>
        </div>
      </DialogActions>
    </Dialog>
  )
})

export default CreateOrder
